import React, { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Table, Form, Button, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import pdfimage from "../images/pdf_downlaod.png";
import Swal from "sweetalert2";
import { IconButton } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import {
  FaChevronDown,
  FaEye,
  FaDownload,
  FaTrash,
  FaUpload,
  FaEdit,
  FaReceipt,
  FaTimes,
} from "react-icons/fa";
import Papa from "papaparse";
import { useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import { BASE_URL } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";

const SendbackDetailPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { invoice, vendorId, isExcelUpload } = state || {};
  console.log("hello this is data ", invoice);
  const { user } = useContext(AuthContext);

  const fileInputRef = useRef();
  const modalFileInputRef = useRef();
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isGSTApplied, setIsGSTApplied] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [caseCount, setCaseCount] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [modalActionType, setModalActionType] = useState("");
  const [fieldErrors, setFieldErrors] = useState({
    invoiceNo: false,
    invoiceDate: false,
    invoiceAmount: false,
    caseCount: false,
    uploadedFile: false,
    remarks: {},
  });
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [batchRemark, setBatchRemark] = useState("");

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editValues, setEditValues] = useState({
    serviceCharges: "",
    repairCharges: "",
    remarks: "",
    file: null,
    fileName: "",
  });

  const itemsPerPage = 10;
  const totalPages = Math.ceil(invoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = invoices.slice(indexOfFirstItem, indexOfLastItem);
  const selectedAAno = invoices.filter((invoice) => invoice.isChecked);

  const totalRepairCharges = currentInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalServiceCharges = currentInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const grossAmount = totalServiceCharges + totalRepairCharges;




  const gstAmount = isGSTApplied
    ? (totalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);
  const totalservicechargewithGST = (totalServiceCharges + parseFloat(gstAmount)).toFixed(2);

  const finalAmount = (
    totalRepairCharges +
    totalServiceCharges +
    parseFloat(gstAmount)
  ).toFixed(2);


  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    console.log("Selected Batch Data:", invoice);
    if (!invoice) {
      navigate("/invoice");
      return;
    }

    if (!invoice.gst || invoice.gst === "0.00") {
      setIsGSTApplied(false);
    } else {
      setIsGSTApplied(true);
    }
    setInvoiceNo(invoice.invoiceNo || "");
    // setInvoiceDate(invoice.invoiceDate || "");
    setInvoiceDate(
      invoice.invoiceDate
        ? new Date(invoice.invoiceDate).toISOString().split("T")[0]
        : ""
    );
    setInvoiceAmount(
      invoice.invoiceAmount
        ? invoice.invoiceAmount.toString()
        : ""
    );
    setCaseCount(
      invoice.caseCount ? invoice.caseCount.toString() : ""
    );

    setIsLoading(true);
    if (invoice.aaNo) {
      const aaNumbers = invoice.aaNo
        .split(",")
        .map((val) => val.trim());

      Promise.all(
        aaNumbers.map((aaNo) =>
          fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNo}`)
            .then((response) => {
              if (!response.ok) {
                console.error(
                  `HTTP error for aaNo ${aaNo}: ${response.status}`
                );
                return null;
              }
              return response.json();
            })
            .then((responseData) => {
              if (!responseData || responseData.status === false) {
                return { status: false, aA_Number: aaNo, dataItems: [] };
              }
              const remarkFileUrl =
                responseData?.dataItems?.[0]?.remarkFileUrl || null;
              const remarks =
                responseData?.dataItems?.[0]?.remarks || null;
              return {
                status: responseData.status,
                aA_Number: aaNo,
                dataItems: Array.isArray(responseData.dataItems)
                  ? responseData.dataItems
                  : [],
                remarkFileUrl, remarks
              };
            })
            .catch((error) => {
              console.error(`Error fetching API data for ${aaNo}:`, error);
              return [];
            })
        )
      )
        .then((results) => {
          const combinedData = results.flat().filter((item) => item);
          setApiData(combinedData);
        })
        .catch((error) => {
          console.error("Error in Promise.all:", error);
          setApiData([]);
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [invoice, navigate]);
  const hasAnySelected = invoices.some(inv => inv.isChecked);

  useEffect(() => {
    if (!invoice) return;
    const splitData = (key) =>
      invoice[key]?.split(",").map((val) => val.trim()) || [];
    const remainAAArray = splitData("remainAA");
    const utrArray = splitData("utr");
    const utrMap = {};
    remainAAArray.forEach((aa, i) => {
      if (aa && aa !== "-") utrMap[aa] = utrArray[i] || "-";
    });

    const invoicesArray = splitData("aaNo").map((_, i) => {
      const remarkFileUrl = splitData("remarkFile")[i];
      return {
        aA_Number: splitData("aaNo")[i],
        imeiNumber: splitData("imeiNo")[i],
        creationDate: invoice.creationDate || "",
        closureDate: invoice.closureDate || "",
        customerName: splitData("customerName")[i],
        serviceType: splitData("serviceType")[i],
        brand: splitData("brand")[i],
        makeModel: splitData("makeModel")[i],
        repairCharges: splitData("repairCharges")[i]
          ? parseFloat(splitData("repairCharges")[i]).toFixed(2)
          : "0.00",
        serviceCharges: splitData("serviceCharges")[i]
          ? parseFloat(splitData("serviceCharges")[i]).toFixed(2)
          : "0.00",
        total: splitData("total")[i]
          ? parseFloat(splitData("total")[i]).toFixed(2)
          : "0.00",
        invoiceStatus: invoice.invoiceStatus || "-",
        networkAndFinanceStatus: splitData("networkAndFinanceStatus")[i],
        sellingPartner: splitData("sellingPartner")[i],
        batchNo: invoice.batchNo || "",
        uniqueAABackPartial: invoice.uniqueAABackPartial,
        isChecked: true,
        remarks: splitData("remarks")[i] || "",
        remarkFile: remarkFileUrl
          ? { name: remarkFileUrl.split("/").pop(), url: remarkFileUrl }
          : null,
        utrNo: utrMap[splitData("aaNo")[i]] || "-",
      };
    });
    //   setInvoices(invoicesArray);
    // }, [invoice]);

    // Step 1: Merge localStorage edits first
    const storedInvoices = JSON.parse(localStorage.getItem("invoices") || "[]");

    const mergedWithLocal = invoicesArray.map((invoice) => {
      const stored = storedInvoices.find(
        (item) => item.aA_Number === invoice.aA_Number
      );

      return stored
        ? {
          ...invoice,
          serviceCharges: stored.serviceCharges,
          repairCharges: stored.repairCharges,
          chargesInclGST: stored.chargesInclGST,
          total: stored.total,
          remarks: stored.remarks || invoice.remarks,
          remarkFileUrl: stored.remarkFile || invoice.remarkFileUrl,
        }
        : invoice;
    });

    // Step 2: Merge API data for latest remarks / files
    const mergedWithApi = mergedWithLocal.map((invoice) => {
      const apiMatch = apiData?.find(
        (apiItem) => apiItem?.aA_Number === invoice.aA_Number
      );
      if (!apiMatch) return invoice;

      const apiRemarks =
        apiMatch?.dataItems?.[0]?.remarks || apiMatch?.remarks || invoice.remarks;
      const apiRemarkFile =
        apiMatch?.remarkFileUrl || invoice.remarkFileUrl || null;

      return {
        ...invoice,
        remarks: apiRemarks,
        remarkFileUrl: apiRemarkFile,
      };
    });

    setInvoices(mergedWithApi);
  }, [invoice, apiData]);

  const normalize = (value) =>
    (value ? value.toString().trim() : "").toLowerCase();
  const getRowClassName = useCallback(
    (invoice) => {
      if (!Array.isArray(apiData) || apiData.length === 0) return "row-red";
      const matchedData = apiData.find(
        (item) => item.aA_Number === invoice.aA_Number
      );
      if (!matchedData || matchedData.status === false) return "row-red";
      if (
        matchedData.status === true &&
        Array.isArray(matchedData.dataItems) &&
        matchedData.dataItems.length > 0
      ) {
        const dataItem = matchedData.dataItems[0];
        if (
          normalize(dataItem.serviceType) !== normalize(invoice.serviceType) ||
          normalize(dataItem.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(dataItem.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(dataItem.total) !== normalize(invoice.total) ||
          normalize(dataItem.imeiNumber) !== normalize(invoice.imeiNumber)
          //  ||
          // normalize(dataItem.sellingPartner) !==
          // normalize(invoice.sellingPartner)
        ) {
          return "row-yellow";
        }
        return "row-green";
      }
      return "row-red";
    },
    [apiData]
  );

  const getDifferencesData = (invoice) => {
    const matchedData = apiData.find(
      (item) => item.aA_Number === invoice.aA_Number
    );
    if (!matchedData || matchedData.status === false)
      return [{ field: "AA Number", table: invoice.aA_Number, api: "" }];
    const dataItem = matchedData.dataItems[0] || {};
    const differences = [];
    if (normalize(dataItem.serviceType) !== normalize(invoice.serviceType)) {
      differences.push({
        field: "Service Type",
        table: invoice.serviceType || "",
        api: dataItem.serviceType || "",
      });
    }
    if (normalize(dataItem.imeiNumber) !== normalize(invoice.imeiNumber)) {
      differences.push({
        field: "IMEI Number",
        table: invoice.imeiNumber || "",
        api: dataItem.imeiNumber || "",
      });
    }
    // if (
    //   normalize(dataItem.sellingPartner) !== normalize(invoice.sellingPartner)
    // ) {
    //   differences.push({
    //     field: "Selling Partner",
    //     table: invoice.sellingPartner || "",
    //     api: dataItem.sellingPartner || "",
    //   });
    // }
    if (
      normalize(dataItem.repairCharges) !== normalize(invoice.repairCharges)
    ) {
      differences.push({
        field: "Repair Charges",
        table: invoice.repairCharges || "",
        api: dataItem.repairCharges || "",
      });
    }
    if (
      normalize(dataItem.serviceCharges) !== normalize(invoice.serviceCharges)
    ) {
      differences.push({
        field: "Service Charges",
        table: invoice.serviceCharges || "",
        api: dataItem.serviceCharges || "",
      });
    }
    // if (
    //   normalize(dataItem.chargesInclGST) !== normalize(invoice.chargesInclGST)
    // ) {
    //   differences.push({
    //     field: "GST Charges",
    //     table: invoice.chargesInclGST || "",
    //     api: dataItem.chargesInclGST || "",
    //   });
    // }
    if (normalize(dataItem.total) !== normalize(invoice.total)) {
      differences.push({
        field: "Total Amount",
        table: invoice.total || "",
        api: dataItem.total || "",
      });
    }
    return differences.length > 0 ? differences : [];
  };

  const handleDelete = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedInvoices = invoices.filter((_, i) => i !== index);
        setInvoices(updatedInvoices);

        Swal.fire("Deleted!", "Your record has been deleted.", "success");

        if (updatedInvoices.length === 0) {
          navigate("/invoice");
        }
      }
    });
  };

  const handleCheckboxChange = (invoiceId) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((invoice) =>
        invoice.aA_Number === invoiceId
          ? { ...invoice, isChecked: !invoice.isChecked }
          : invoice
      )
    );
  };
  const handleDownloadInvoice = () => {
    const invoiceUrl = invoice?.invoice;
    if (!invoiceUrl) {
      toast.error("No invoice URL available for download.");
      return;
    }
    const fileName = invoiceUrl.split("/").pop() || "invoice.pdf";
    const link = document.createElement("a");
    link.href = invoiceUrl;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file, 'filelelell')
    if (!file) return;
    const extension = file.name.split(".").pop().toLowerCase();
    setFileType(extension);
    setUploadedFile(file);
    setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));
    if (extension === "csv") {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          const row = results.data[0];
          setInvoiceNo(row["Invoice No"] || invoice.invoiceNo || "");
          setInvoiceDate(
            row["Invoice Date"] || invoice.invoiceDate || ""
          );
          setInvoiceAmount(
            row["Invoice Amount"]
              ? row["Invoice Amount"].toString()
              : invoice.invoiceAmount
                ? invoice.invoiceAmount.toString()
                : ""
          );
          setCaseCount(
            row["Case Count"]
              ? row["Case Count"].toString()
              : invoice.caseCount
                ? invoice.caseCount.toString()
                : ""
          );
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          toast.error("Failed to read CSV file.");
        },
      });
    }
  };

  const downloadCSV = () => {
    const headers = [
      "AANumber",
      "IMEINumber",
      "CustomerName",
      // "ServiceType",
      "Brand",
      "MakeModel",
      "RepairCharges",
      "ServiceCharges (Pre GST)",
      "Total",
      "InvoiceStatus",
      // "Remarks",
      // "RemarkFile",
      // "Remarks",
      // "Remark File",
    ];

    const today = new Date().toLocaleDateString("en-GB");

    const data = selectedAAno.map((invoice) => ({

      aaNumber: invoice.aA_Number || "",
      imeiNumber: invoice.imeiNumber ? `="${invoice.imeiNumber}"` : "",
      customerName: invoice.customerName || "",
      // serviceType: invoice.serviceType || "",
      brand: invoice.brand || "",
      makeModel: invoice.makeModel || "",
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      total: invoice.total || "0.00",
      invoiceStatus: invoice.networkAndFinanceStatus || "",

      // remarks: invoice.remarks || "",
      // remarkFile: invoice.remarkFile
      //   ? invoice.remarkFile.name || invoice.remarkFile
      //   : "",

    }));

    const csv = Papa.unparse({
      fields: headers,
      data: data.map(row => Object.values(row)),
    }, {
      quotes: true,
      quoteChar: '"',
      delimiter: ',',
      newline: '\r\n'
    });

    const vendorName =
      selectedAAno?.[0]?.sellingPartner?.replace(/\s+/g, "_") || "invoice";

    const fileName = `${vendorName}_list.csv`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const getAllowedAANumbers = () => {
    const aaNumbers = currentInvoices
      .map(invoice => invoice.uniqueAABackPartial)
      .filter(Boolean);

    if (aaNumbers.length === 0) return [];

    return aaNumbers.flatMap(aaString =>
      aaString.split(",").map(aa => aa.trim())
    );
  };
  const handleViewClick = (aaNumber) => {
    sessionStorage.setItem('preserveInvoices', 'true');
    navigate("/invoice-template", { state: { aaNumber } });
  };

  const handleBackClick = () => {
    localStorage.removeItem("invoices");
    navigate(-1);
  };
  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('preserveInvoices') !== 'true') {
        localStorage.removeItem("invoices");
      }
      sessionStorage.removeItem('preserveInvoices');
    };
  }, []);

  const isRowDisabled = (invoice) => {
    const allowedAA = getAllowedAANumbers();

    if (allowedAA.length === 0) return true;

    return !allowedAA.includes(invoice.aA_Number);
  };
  const selectedInvoices = invoices.filter((invoice) => invoice.isChecked && !isRowDisabled(invoice));

  const leftSideTotalRepairCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideTotalServiceCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideGstAmount = isGSTApplied
    ? (leftSideTotalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const leftSideGrossAmount = leftSideTotalRepairCharges + leftSideTotalServiceCharges;
  const leftSideFinalAmount = isGSTApplied
    ? (leftSideGrossAmount + parseFloat(leftSideGstAmount)).toFixed(2)
    : leftSideGrossAmount.toFixed(2);

  const leftSideTotalservicechargewithGST = (leftSideTotalServiceCharges + parseFloat(leftSideGstAmount)).toFixed(2);
  const leftSideCaseCount = selectedInvoices.length;


  const handleSubmit = async () => {
    try {
      const validInvoices = invoices.filter(inv => !isRowDisabled(inv));

      const selected = validInvoices.filter(inv => inv.isChecked);
      const unselected = validInvoices.filter(inv => !inv.isChecked);

      if (selected.length === 0) {
        toast.error("Please select at least one invoice.");
        return;
      }

      const invoiceAmountStr = invoiceAmount ? invoiceAmount.toString() : "";
      const caseCountStr = caseCount ? caseCount.toString() : "";

      if (!invoiceNo.trim()) {
        toast.error("Invoice No is required.");
        return;
      }
      if (!invoiceDate) {
        toast.error("Invoice Date is required.");
        return;
      }
      if (!invoiceAmountStr.trim() || isNaN(parseFloat(invoiceAmountStr)) || parseFloat(invoiceAmountStr) <= 0) {
        toast.error("Invoice Amount must be a valid positive number.");
        return;
      }
      if (!caseCountStr.trim() || isNaN(parseInt(caseCountStr)) || parseInt(caseCountStr) <= 0) {
        toast.error("Case Count must be a valid positive number.");
        return;
      }

      const today = new Date().toISOString().split("T")[0];
      if (invoiceDate > today) {
        toast.error("Invoice Date cannot be a future date.");
        return;
      }

      // const parsedCaseCount = parseInt(caseCountStr);
      // if (parsedCaseCount !== selected.length) {
      //   toast.error("Case Count does not match the number of selected services.");
      //   return;
      // }

      const parsedInvoiceAmount = parseFloat(invoiceAmountStr);
      if (Math.abs(parsedInvoiceAmount - parseFloat(finalAmount)) > 0.01) {
        setAmountError("Invoice Amount and Final Amount do not match.");
        return;
      } else {
        setAmountError("");
      }

      const extract = (arr, key) => arr.map(item => item[key] || "").join(", ");
      const extractSingle = (arr, key) => {
        const values = arr.map(item => item[key]).filter(Boolean);
        return values.length > 0 ? values[0] : null;
      };
      const previousStatusMap = invoices.reduce((acc, inv) => {
        if (inv.aA_Number && inv.networkAndFinanceStatus) {
          acc[inv.aA_Number] = inv.networkAndFinanceStatus;
        }
        return acc;
      }, {});

      const effectiveSelectedInvoices = selected.filter(
        inv => !isRowDisabled(inv)
      );

      const allAA = invoices.map(inv => inv.aA_Number).filter(Boolean);

      const statusList = allAA.map(invAA => {
        if (effectiveSelectedInvoices.some(inv => inv.aA_Number === invAA)) {
          return "Approval Pending";
        }

        if (isRowDisabled({ aA_Number: invAA })) {
          return previousStatusMap[invAA] || "Approval Pending";
        }

        return "Approval Pending";
      });

      const networkAndFinanceStatus = statusList.join(",");

      const payload = {
        sellingPartner: extract(invoices, "sellingPartner"),
        aaNo: extract(invoices, "aA_Number"),
        imeiNo: extract(invoices, "imeiNumber"),
        creationDate: extractSingle(selected, "creationDate"),
        closureDate: extractSingle(selected, "closureDate"),
        customerName: extract(invoices, "customerName"),
        serviceType: extract(invoices, "serviceType"),
        brand: extract(invoices, "brand"),
        makeModel: extract(invoices, "makeModel"),
        repairCharges: extract(invoices, "repairCharges"),
        total: extract(invoices, "total"),
        invoiceStatus: selected.length === validInvoices.length ? "Pending" : "",
        batchNo: invoice?.batchNo || "",
        selectedService: "",
        totalRepairCharges: leftSideTotalRepairCharges.toFixed(2),
        serviceCharges: extract(invoices, "serviceCharges"),
        finalAmount: leftSideFinalAmount,
        gst: leftSideGstAmount || "",
        invoiceNo: invoiceNo,
        invoiceDate: invoiceDate,
        invoiceAmount: invoiceAmountStr,
        invoice: uploadedFile
          ? uploadedFile.name
          : (invoice?.invoice ? invoice.invoice.split("fileName=")[1] : ""),
        vendorName: invoice?.vendorName || "",
        // caseCount: parseInt(caseCountStr),
        caseCount: caseCount,

        totalServiceCharges: leftSideTotalservicechargewithGST,
        remarks: extract(selected, "remarks"),
        remarkFile: selected.find(inv => inv.remarkFile)?.remarkFile?.name || "",
        uniqueAABackPartial: unselected.map(inv => inv.aA_Number).join(","),
        uniquePending: selected.map(inv => inv.aA_Number).join(","),
        type: "Back",
        NetworkAndFinanceStatus: networkAndFinanceStatus
      };

      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/BackToPending`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      setIsLoading(false);

      if (!response.ok) {
        toast.error("Error submitting batch. Check payload or try again.");
        return;
      }
      const aanoString = selected.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch Send to Back for approval");
      remarkFormData.append("BatchNo", invoice?.batchNo);
      remarkFormData.append("ByWhom", user?.role);
      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }
      toast.success("Batch submitted successfully.");
      localStorage.removeItem("invoices");
      navigate("/approval");

    } catch (error) {
      console.error("Submission failed:", error);
      setIsLoading(false);
      toast.error("Submission failed. Please check console for details.");
    }
  };

  const handleSaveData = async () => {
    try {
      const selected = invoices.filter((inv) => inv.isChecked);
      if (selected.length === 0) {
        toast.error("Please select at least one invoice.");
        return;
      }

      const invoiceAmountStr = invoiceAmount ? invoiceAmount.toString() : "";
      const caseCountStr = caseCount ? caseCount.toString() : "";

      const newErrors = {
        invoiceNo: !invoiceNo.trim(),
        invoiceDate: !invoiceDate,
        invoiceAmount:
          !invoiceAmountStr.trim() ||
          isNaN(parseFloat(invoiceAmountStr)) ||
          parseFloat(invoiceAmountStr) <= 0,
        caseCount:
          !caseCountStr.trim() ||
          isNaN(parseInt(caseCountStr)) ||
          parseInt(caseCountStr) <= 0,
        uploadedFile: !uploadedFile && !invoice?.invoice,
        remarks: {},
      };

      let hasRemarkError = false;
      selected.forEach((invoice) => {
        const isYellowRow = getRowClassName(invoice) === "row-yellow";
        const isRemarkEmpty = !invoice.remarks?.trim();
        if (isYellowRow && isRemarkEmpty) {
          newErrors.remarks[invoice.aA_Number] = true;
          hasRemarkError = true;
        } else {
          newErrors.remarks[invoice.aA_Number] = false;
        }
      });

      setFieldErrors(newErrors);

      if (!uploadedFile && !invoice?.invoice) {
        newErrors.uploadedFile = "Please upload an invoice file.";
      }
      if (newErrors.invoiceNo) {
        toast.error("Invoice No is required.");
      }
      if (newErrors.invoiceDate) {
        toast.error("Invoice Date is required.");
      }
      if (newErrors.invoiceAmount) {
        toast.error("Invoice Amount must be a valid positive number.");
      }
      if (newErrors.caseCount) {
        toast.error("Case Count must be a valid positive number.");
      }
      if (hasRemarkError) {
        toast.error(
          "Remarks are required for all yellow rows (mismatched data)."
        );
      }

      if (
        Object.values(newErrors).some((error) => error === true) ||
        hasRemarkError
      ) {
        return;
      }

      const today = new Date().toISOString().split("T")[0];
      if (invoiceDate > today) {
        setFieldErrors((prev) => ({ ...prev, invoiceDate: true }));
        toast.error("Invoice Date cannot be a future date.");
        return;
      }

      const parsedCaseCount = parseInt(caseCountStr);
      if (parsedCaseCount !== selected.length) {
        setFieldErrors((prev) => ({ ...prev, caseCount: true }));
        toast.error(
          "Case Count does not match the number of selected services."
        );
        return;
      }

      const parsedInvoiceAmount = parseFloat(invoiceAmountStr);
      if (Math.abs(parsedInvoiceAmount - parseFloat(finalAmount)) > 0.01) {
        setFieldErrors((prev) => ({ ...prev, invoiceAmount: true }));
        setAmountError("Invoice Amount and Final Amount do not match.");
        return;
      } else {
        setAmountError("");
      }

      let hasMismatch = false;
      for (const invoice of selected) {
        const matchedData = apiData.find(
          (item) => item.aA_Number === invoice.aA_Number
        );
        if (!matchedData) {
          toast.error(
            `AA Number ${invoice.aA_Number} not found in reference data. Please delete the row or check the source.`
          );
          return;
        }

        // if (
        //   normalize(matchedData.serviceType) !==
        //   normalize(invoice.serviceType) ||
        //   normalize(matchedData.repairCharges) !==
        //   normalize(invoice.repairCharges) ||
        //   normalize(matchedData.serviceCharges) !==
        //   normalize(invoice.serviceCharges) ||
        //   normalize(matchedData.total) !== normalize(invoice.total)
        // ) {
        //   hasMismatch = true;
        // }

        const dataItem = matchedData.dataItems?.[0] || {};

        if (
          normalize(dataItem.serviceType) !== normalize(invoice.serviceType) ||
          normalize(dataItem.repairCharges) !== normalize(invoice.repairCharges) ||
          normalize(dataItem.serviceCharges) !== normalize(invoice.serviceCharges) ||
          normalize(dataItem.total) !== normalize(invoice.total)
        ) {
          hasMismatch = true;
        }
      }

      if (hasMismatch) {
        const confirmProceed = window.confirm(
          "Warning: Some invoice fields do not match the original data.\nDo you want to proceed anyway?"
        );
        if (!confirmProceed) return;
      }
      const normalizeDateForSQL = (dateStr) => {
        if (!dateStr || dateStr.trim() === "") return "";
        const date = new Date(dateStr);
        if (isNaN(date)) return "";
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const mi = String(date.getMinutes()).padStart(2, "0");
        const ss = String(date.getSeconds()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
      };

      const extractWithSQLDate = (key) => {
        if (!selected.length) return "";
        return normalizeDateForSQL(selected[0][key]);
      };

      const formData = new FormData();
      const extract = (key) =>
        selected.map((item) => item[key] || "").join(", ");
      formData.append("AANo", extract("aA_Number"));
      formData.append("IMEINo", extract("imeiNumber"));

      formData.append("CreationDate", extractWithSQLDate("creationDate"));
      formData.append("ClosureDate", extractWithSQLDate("closureDate"));
      formData.append("CustomerName", extract("customerName"));
      formData.append("Remarks", extract("remarks"));
      formData.append("VendorName", invoice?.vendorName || "");
      formData.append("finalAmount", leftSideFinalAmount);
      formData.append("TotalRepairCharges", leftSideTotalRepairCharges.toFixed(2));
      formData.append("TotalServiceCharges", leftSideTotalservicechargewithGST);
      formData.append("GST", leftSideGstAmount || "");
      formData.append("BatchNo", invoice?.batchNo || "");
      formData.append("ServiceType", extract("serviceType"));
      formData.append("Brand", extract("brand"));
      formData.append("MakeModel", extract("makeModel"));
      formData.append("RepairCharges", extract("repairCharges"));
      formData.append("ServiceCharges", extract("serviceCharges"));
      formData.append("Total", extract("total"));
      formData.append("SellingPartner", extract("sellingPartner"));
      formData.append(
        "InvoiceStatus",
        uploadedFile || invoice?.invoice ? "Invoice Uploaded" : ""
      );
      formData.append("InvoiceNo", invoiceNo);
      formData.append("Type", "Back");

      formData.append("InvoiceDate", normalizeDateForSQL(invoiceDate));
      formData.append("InvoiceAmount", invoiceAmountStr);
      formData.append("CaseCount", caseCount);
      formData.append("IsGSTApplied", isGSTApplied ? "true" : "false");
      if (uploadedFile) {
        formData.append("Invoice", uploadedFile, uploadedFile.name);
        console.log(uploadedFile, 'uploaded file');
      }
      else if (invoice?.invoice) {
        const fileUrl = invoice?.invoice || "";
        const fileName = fileUrl ? fileUrl.split("fileName=")[1] : "";

        formData.append("Invoice", fileName);
        console.log(fileName, "fileName");
      }
      else {
        formData.append("Invoice", null);
        console.log('No invoice file or link found');
      }


      const invoiceWithFile = selected.find((inv) => inv.remarkFile);

      if (invoiceWithFile) {
        const remark = invoiceWithFile.remarkFile;

        if (remark instanceof File) {
          // If a new file was uploaded via the modal
          formData.append("RemarkFile", remark, remark.name);
        } else if (remark?.url && typeof remark.url === "string") {
          // If the file is coming as URL from previous page
          const fileName = remark.name || "remark-file.pdf";
          try {
            const response = await fetch(remark.url);
            if (response.ok) {
              const blob = await response.blob();
              formData.append("RemarkFile", blob, fileName);
            } else {
              // Append null silently if fetch fails
              formData.append("RemarkFile", null);
            }
          } catch (err) {
            // Do not toast error, just append null
            formData.append("RemarkFile", null);
          }
        } else {
          // No valid file or URL
          formData.append("RemarkFile", null);
        }
      } else {
        // No invoiceWithFile case
        formData.append("RemarkFile", null);
      }

      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/UpdateBackPartialData`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      setIsLoading(false);

      if (!response.ok) {
        toast.error("Error submitting batch. Check the payload or try again.");
        return;
      }
      const aanoString = selected.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch saved");
      remarkFormData.append("BatchNo", invoice?.batchNo);
      remarkFormData.append("ByWhom", user?.role);

      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }
      toast.success("Batch Saved successfully.");
      localStorage.removeItem("invoices");
      navigate("/sendBackByapproval");
    } catch (error) {
      console.error("Submission failed:", error);
      setIsLoading(false);
      toast.error("Submission failed. Please check console for details.");
    }
  };
  // const handleSaveRemark = async (actionType) => {
  //   try {
  //     const selected = invoices.filter((inv) => inv.isChecked);
  //     const aaNumbers = selected.map((inv) => inv.aA_Number).join(",");
  // 
  //     if (!aaNumbers) {
  //       console.warn("No AA Numbers found for remark update");
  //       return true;
  //     }
  //     let logsMessage = "";
  //     switch (actionType) {
  //       case "Approved":
  //         logsMessage = `${aaNumbers} ${selected.length > 1 ? "have" : "has"} been approved`;
  //         break;
  //       case "Saved":
  //         logsMessage = `Batch saved`;
  //         break;
  //       default:
  //         logsMessage = `${aaNumbers} action: ${actionType}`;
  //         break;
  //     }
  // 
  //     const formData = new FormData();
  //     formData.append("aA_Number", aaNumbers);
  //     formData.append("remarks", batchRemark || "");
  //     formData.append("remarkAndLogBy", user.role);
  //     formData.append("batchNo", invoice?.batchNo);
  //     // formData.append("logs", actionType === "Approved" ? "Batch Approved" : "Batch Saved");
  //     formData.append("logs", logsMessage);
  // 
  //     const res = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
  //       method: "POST",
  //       body: formData,
  //     });
  // 
  //     const data = await res.json();
  // 
  //     if (!res.ok || !data.status) {
  //       toast.error(data.message || `Failed to ${actionType} remark.`);
  //       return;
  //     }
  // 
  //     toast.success(`Remark ${actionType === "Submitted" ? "submitted" : "saved"} successfully.`);
  //     setShowRemarkModal(false);
  // 
  //     if (actionType === "Submitted") {
  //       handleSubmit();
  //     } else {
  //       handleSaveData();
  //     }
  //   } catch (err) {
  //     console.error("Remark update failed:", err);
  //     toast.error("Failed to update remark.");
  //   }
  // };

  const handleEdit = (invoice) => {
    setEditingInvoice(invoice);
    setEditValues({
      serviceCharges: invoice.serviceCharges || "0.00",
      repairCharges: invoice.repairCharges || "0.00",
      remarks: invoice.remarks || "",
      file: invoice.remarkFile instanceof File ? invoice.remarkFile : null,
      fileName:
        invoice.remarkFile && typeof invoice.remarkFile === "object"
          ? invoice.remarkFile.name
          : invoice.remarkFile || "",
    });
    setShowEditModal(true);
  };

  const handleSaveEdit = async () => {
    if (!editingInvoice) return;
    setIsLoading(true);
    try {
      const parsedServiceCharges = parseFloat(editValues.serviceCharges);
      const parsedRepairCharges = parseFloat(editValues.repairCharges);
      const remarks = editValues.remarks?.trim() || "";

      if (
        isNaN(parsedServiceCharges) ||
        parsedServiceCharges < 0 ||
        isNaN(parsedRepairCharges) ||
        parsedRepairCharges < 0
      ) {
        toast.error(
          "Service Charges and Repair Charges must be valid non-negative numbers."
        );
        return;
      }

      const isYellowRow = getRowClassName(editingInvoice) === "row-yellow";
      if (isYellowRow && !remarks) {
        setFieldErrors((prev) => ({
          ...prev,
          remarks: { ...prev.remarks, [editingInvoice.aA_Number]: true },
        }));
        toast.error("Remarks are required for mismatched data.");
        return;
      }

      try {
        const formData = new FormData();
        formData.append("aano", editingInvoice?.aA_Number);
        formData.append("remark", editValues.remarks);
        formData.append("remarkFile", editValues.file);
        formData.append("RemarkBy", user.role);
        formData.append("BillingType", editingInvoice?.billingType || "billing");
        formData.append("Document", null);

        const response = await fetch(`${BASE_URL}/UpdateClaimRemarks`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (data.status) {
          alert("Remark updated successfully");
          toast.success("Remark updated successfully.");
          const refreshResponse = await fetch(
            `${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${editingInvoice.aA_Number}`
          );

          if (refreshResponse.ok) {
            const refreshedData = await refreshResponse.json();

            setApiData((prev) => {
              const updated = prev.map((item) =>
                item.aA_Number === editingInvoice.aA_Number
                  ? {
                    ...item,
                    ...refreshedData,
                    remarkFileUrl:
                      refreshedData?.dataItems?.[0]?.remarkFileUrl || null,
                    remarks:
                      refreshedData?.dataItems?.[0]?.remarks || null,
                  }
                  : item
              );
              return updated;
            });
          }
          handleCloseModal();
        } else {
          alert("Failed to update: " + (data.message || "Unknown error"));
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Network error: " + error.message);
      }

      const formattedServiceCharges = parsedServiceCharges.toFixed(2);
      const formattedRepairCharges = parsedRepairCharges.toFixed(2);
      const formattedTotal = (parsedServiceCharges + parsedRepairCharges).toFixed(
        2
      );

      setInvoices((prevInvoices) => {
        const updated = prevInvoices.map((invoice) =>
          invoice.aA_Number === editingInvoice.aA_Number
            ? {
              ...invoice,
              serviceCharges: formattedServiceCharges,
              repairCharges: formattedRepairCharges,
              total: formattedTotal,
              remarks: remarks,
              remarkFile: editValues.file
                ? editValues.file
                : editValues.fileName
                  ? { name: editValues.fileName, url: editValues.fileName }
                  : null,
            }
            : invoice
        )
        localStorage.setItem("invoices", JSON.stringify(updated));

        return updated;
      });
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
      }));
      setShowEditModal(false);
      setEditingInvoice(null);
      setEditValues({
        serviceCharges: "",
        repairCharges: "",
        remarks: "",
        file: null,
        fileName: "",
      });
    } catch (err) {
      console.error(err);
      toast.error("Network error: " + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const storedInvoices = localStorage.getItem("invoices");
    if (storedInvoices) {
      setInvoices(JSON.parse(storedInvoices));
    }
  }, []);
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditValues((prev) => ({ ...prev, [name]: value }));
    if (name === "remarks" && editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: !value.trim() },
      }));
    }
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      remarks: "",
      file: null,
      fileName: "",
    });
    if (editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
      }));
    }
  };

  const handleRemarkChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditValues((prev) => ({
        ...prev,
        file,
        fileName: file.name,
      }));
    }
  };
  const getFileNameFromUrl = (url) => {
    const params = new URLSearchParams(url.split("?")[1]);
    return decodeURIComponent(params.get("fileName"));
  };
  useEffect(() => {
    setCaseCount(selectedAAno?.length || 0);
    setInvoiceAmount(
      !isNaN(parseFloat(finalAmount)) ? parseFloat(finalAmount).toFixed(2) : ""
    );
  }, [selectedAAno, finalAmount]);

  const formatINVOICEDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";

    if (dateStr.includes("/") || dateStr.includes("-")) {
      const normalized = dateStr.replaceAll("/", "-");
      const parts = normalized.split("-");

      if (parts[0].length === 4) {
        return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
      }

      if (parts[2].length === 4) {
        return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
      }
    }

    return "";
  };

  console.log(currentInvoices, 'curnrrnrn')
  // Collect all uniqueAABackPartial values from invoices
  // const getAllowedAANumbers = () => {
  //   return currentInvoices
  //     .map(invoice => invoice.uniqueAABackPartial)
  //     .filter(Boolean)
  //     .flatMap(aaString => aaString.split(",").map(aa => aa.trim()));
  // };


  // const isRowDisabled = (invoice) => {
  //   const allowedAA = getAllowedAANumbers();
  //   console.log(allowedAA, 'Allowed AAs');
  //   return !allowedAA.includes(invoice.aA_Number);
  // };



  const selectedAAnoCase = invoices.filter(
    (invoice) => invoice.isChecked && !isRowDisabled(invoice)
  );
  const handleLOGSremarks = (aa_number) => {
    navigate(`/Remarks&Logs/${aa_number}`)
  }
  const allRowsChecked =
    invoices.length > 0 && invoices.every((invoice) => invoice.isChecked);

  const hasInvoiceApprovedStatus = () => {
    return invoices.some(invoice =>
      invoice.networkAndFinanceStatus === "Invoice Approved"
    );
  };
  return (
    <div
      className="container py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >

      <ToastContainer position="top-right" autoClose={3000} />
      <div className="card shadow-sm p-4">
        <div
          className="d-flex justify-content-between align-items-center mb-4"
          style={{
            backgroundColor: "#e6f0ff",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h2 className="mb-0">Back From Approval</h2>
          <button
            className="btn btn-primary d-flex align-items-center"
            style={{
              backgroundColor: "#8000d7",
              border: "none",
              padding: "10px 16px",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "14px",
            }}
            // onClick={() => navigate(-1)}
            onClick={handleBackClick}
          >
            Back
          </button>
        </div>

        <div className="netwrok_table_main_content">
          <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
            <div className="d-flex flex-wrap gap-2 align-items-center">
              {invoice?.batchNo && (
                <div className="fw-semibold">
                  <span>Batch No: </span>
                  <span className="text-primary">
                    {invoice.batchNo}
                  </span>
                </div>
              )}
              {invoice?.vendorName && (
                <div className="fw-semibold">
                  <span>Vendor: </span>
                  <span className="text-success">
                    {invoice.vendorName}
                  </span>
                </div>
              )}
            </div>
            <div className="d-flex gap-2">
              {/* <button
                  className="batch_popup_upload"
                  onClick={handleDownloadInvoice}
                >
                  <FaDownload />{" "}
                  <span className="ms-2">Download Invoice</span>
                </button> */}
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
                onClick={handleClick}
              >
                <FaUpload /> <span className="ms-2">Upload Invoice</span>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => {
                  handleFileChange(e);
                  setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));
                }}
                style={{ display: "none" }}
                accept="*"
              />
            </div>
          </div>

          {uploadedFile ? (
            <div className="text-end upload_file_ext_name mb-3">
              <span
                className="fw-bold text-success"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(URL.createObjectURL(uploadedFile), "_blank")}
              >
                {uploadedFile.name}
              </span>

              {fileType === "pdf" ? (
                <img
                  src={pdfimage}
                  alt="PDF Icon"
                  style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                />
              ) : fileType === "image" ? (
                <img
                  src={URL.createObjectURL(uploadedFile)}
                  alt="Image Preview"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginLeft: "10px",
                    objectFit: "cover",
                    borderRadius: "4px",
                  }}
                />
              ) : null}
            </div>
          ) : invoice?.invoice ? (
            // Show old file if no new file is uploaded
            <div className="text-end upload_file_ext_name mb-3">
              <span
                className="fw-bold text-success"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(invoice.invoice, "_blank")}
              >
                {getFileNameFromUrl(invoice?.invoice)}
              </span>
              {invoice.invoice.endsWith(".pdf") ? (
                <img
                  src={pdfimage}
                  alt="PDF Icon"
                  style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                />
              ) : null}
            </div>
          ) : null}

          {!uploadedFile && !invoice?.invoice && fieldErrors.uploadedFile && (
            <div className="text-danger mb-3" style={{ fontSize: "14px" }}>
              Please upload an invoice file.
            </div>
          )}
          <div
            className="table-container mt-3"
            style={{ overflowX: "auto", overflowY: "auto" }}
          >
            <Table className="table-auto bg-white text-center border-dark network_table">
              <thead
                style={{
                  backgroundColor: "#EEF4FF",
                  position: "sticky",
                  top: "0",
                  zIndex: "1",
                }}
              >
                <tr className="text-dark fw-semibold table_th_border">
                  <th className="border-start">Select</th>
                  <th className="border-start">View</th>
                  <th className="border-start">Edit</th>
                  <th className="border-start">Remarks</th>
                  <th style={{ whiteSpace: "nowrap" }}>AA No</th>
                  <th style={{ whiteSpace: "nowrap" }}>IMEI No</th>
                  {/* <th style={{ whiteSpace: "nowrap" }}>Creation Date</th> */}
                  {/* <th style={{ whiteSpace: "nowrap" }}>Closure Date</th> */}
                  <th style={{ whiteSpace: "nowrap" }}>Customer Name</th>
                  {/* <th style={{ whiteSpace: "nowrap" }}>Service Type</th>
                  <th style={{ whiteSpace: "nowrap" }}>Selling Partner</th> */}
                  <th style={{ whiteSpace: "nowrap" }}>Brand</th>
                  <th style={{ whiteSpace: "nowrap" }}>Make Model</th>
                  <th style={{ whiteSpace: "nowrap" }}>Repair Charges</th>
                  <th style={{ whiteSpace: "nowrap" }}>Logistics and Repair Support Fees(Pre GST)</th>
                  <th style={{ whiteSpace: "nowrap" }}>Total</th>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice Status</th>
                  <th style={{ whiteSpace: "nowrap" }}>UTR No</th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Mismatched Data
                  </th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Remarks
                  </th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Remark File
                  </th>
                  {/* <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Action
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan="20" className="text-center py-3">
                      Validating data...
                    </td>
                  </tr>
                )}
                {!isLoading &&
                  currentInvoices.map((invoice, index) => {
                    const disabled = isRowDisabled(invoice);

                    return (
                      <tr
                        key={invoice.id || `${invoice.aA_Number}-${index}`}
                        className={`text-center border-bottom network_td_item ${getRowClassName(invoice)} ${isRowDisabled(invoice) ? 'table-row-disabled' : ''}`}
                        style={{
                          opacity: isRowDisabled(invoice) ? 0.6 : 1,
                          backgroundColor: isRowDisabled(invoice) ? '#f2f2f2' : 'transparent',
                          pointerEvents: isRowDisabled(invoice) ? 'none' : 'auto'
                        }}
                      >
                        <td className="border-start align-middle">
                          <Form.Check
                            type="checkbox"
                            checked={invoice.isChecked}
                            onChange={() =>
                              handleCheckboxChange(invoice.aA_Number)
                            }
                            disabled={disabled}
                          />
                        </td>
                        <td className="border-start align-middle"
                          style={{ pointerEvents: "auto" }}>
                          <IconButton
                            // onClick={() =>
                            //   navigate("/invoice-template", {
                            //     state: {
                            //       aaNumber: invoice.aA_Number,
                            //       invoiceData: invoice,
                            //     },
                            //   })
                            // }
                            onClick={() => handleViewClick(invoice.aA_Number)}

                          >
                            <FaEye
                              size={20}
                              className="text-purple review_fa_eye"
                              style={{ cursor: "pointer" }}
                            />
                          </IconButton>
                        </td>

                        <td className="border-start align-middle">
                          <button
                            onClick={() => handleEdit(invoice)}
                            disabled={isLoading || disabled}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: isLoading || disabled ? "not-allowed" : "pointer"
                            }}
                          >
                            <FaEdit
                              size={20}
                              className="text-purple-600 review_fa_eye"
                            />
                          </button>
                        </td>
                        <td className="border-start align-middle">
                          <FaReceipt
                            size={20}
                            className="text-purple-600 review_fa_eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLOGSremarks(invoice.aA_Number)}
                          />
                        </td>
                        <td className="align-middle">
                          {invoice.aA_Number || "-"}
                        </td>
                        <td className="align-middle">
                          {invoice.imeiNumber || "-"}
                        </td>
                        {/* <td className="align-middle">
                          {new Date().toLocaleDateString("en-GB")}
                        </td> */}
                        {/* <td className="align-middle">
                        {invoice.closureDate || "-"}
                      </td> */}
                        <td className="align-middle">
                          {invoice.customerName || "-"}
                        </td>
                        <td className="align-middle">{invoice.brand || "-"}</td>
                        <td className="align-middle">
                          {invoice.makeModel || "-"}
                        </td>
                        <td className="align-middle">
                          {invoice.repairCharges || "0.00"}
                        </td>
                        <td className="align-middle">
                          {invoice.serviceCharges || "0.00"}
                        </td>
                        <td className="align-middle">
                          {invoice.total || "0.00"}
                        </td>
                        {/* <td className="align-middle">
                          <span
                            className="vendore_invoice_status px-2 py-1 rounded-pill"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {invoice.networkAndFinanceStatus || ""}
                          </span>
                        </td> */}
                        <td className="align-middle">
                          <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                            {invoice.utrNo && invoice.utrNo.trim() !== "-" && invoice.utrNo.trim() !== ""
                              ? "Payment Done"
                              : invoice.networkAndFinanceStatus || "-"}
                          </span>
                        </td>
                        <td className="align-middle">
                          {invoice.utrNo || "-"}
                        </td>
                        <td className="align-middle">
                          {getDifferencesData(invoice).length > 0
                            ? "Mismatch"
                            : "Valid"}
                          <div
                            className="align-middle position-relative"
                            onMouseEnter={() => setHoveredRow(index)}
                            onMouseLeave={() => setHoveredRow(null)}
                            style={{ cursor: "pointer", position: "relative" }}
                          >
                            {getDifferencesData(invoice).length > 0
                              ? "View Details"
                              : ""}
                            {hoveredRow === index &&
                              getDifferencesData(invoice).length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: "-18%",
                                    transform: "translateX(-50%)",
                                    zIndex: "1000",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #ddd",
                                    padding: "10px",
                                    boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                                    minWidth: "300px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <table className="table table-sm table-bordered table-hover mb-0">
                                    <thead>
                                      <tr>
                                        <th className="text-left">Field</th>
                                        <th className="text-left">Excel Data</th>
                                        <th className="text-left">System Data</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {getDifferencesData(invoice).map(
                                        (diff, i) => (
                                          <tr key={i}>
                                            <td className="text-left">
                                              {diff.field}
                                            </td>
                                            <td className="text-left">
                                              {diff.table}
                                            </td>
                                            <td className="text-left">
                                              {diff.api}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                          </div>
                        </td>
                        <td className="align-middle border-end">
                          <span>
                            {invoice.remarks || "-"}
                            {getRowClassName(invoice) === "row-yellow" &&
                              !invoice.remarks && (
                                <span className="text-danger ms-1">*</span>
                              )}
                          </span>
                        </td>
                        <td className="align-middle border-end">
                          {invoice.remarkFileUrl ? (
                            <a
                              href={invoice.remarkFileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#8000d7",
                                textDecoration: "underline",
                              }}
                            >
                              View File
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        {/* <td
                          className="align-middle border-end pointer-cursor"
                          style={{ cursor: "pointer" }}
                        >
                          <FaTrash
                            onClick={() => handleDelete(index)}
                            size={25}
                            style={{ color: "red" }}
                          />
                        </td> */}
                      </tr>
                    )
                  })}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-between align-items-center pagination-container mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>

          <div className="row justify-content-between align-items-start mt-2">
            {/* Left Column */}
            <div className="col-6">
              {/* GST Toggle */}
              <div className="border rounded p-2 mt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="fw-bold ms-2">
                    <span>GST</span>
                  </div>
                  <div className="d-flex gap-3">
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === true}
                        onChange={() => setIsGSTApplied(true)}
                      />
                      <span className="registration_applied_yes">Yes</span>
                    </label>
                    <span className="mx-1">/</span>
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === false}
                        onChange={() => setIsGSTApplied(false)}
                      />
                      <span className="registration_applied_yes">No</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Selected Services */}
              <div
                style={{
                  backgroundColor: "#eef4ff",
                  marginTop: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontWeight: 600, color: "gray" }}>
                  Total no of selected invoices:
                </span>
                <span style={{ fontWeight: "bold", color: "black" }}>
                  {leftSideCaseCount}
                </span>
              </div>

              {/* Amount Summary */}
              <div
                className="batch_popup_gross_ammount mt-2 w-100"
                style={{ backgroundColor: "#eef4ff" }}
              >
                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Repair Charges</div>
                  <div className="text-end batch_amount_to_fix">
                    ₹ {parseFloat(leftSideTotalRepairCharges).toFixed(2)}
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Logistics and Repair Support Fees</div>
                  <div className="d-flex align-items-center">
                    <div className="batch_amount_to_fix">
                      ₹ {leftSideTotalservicechargewithGST} ({isGSTApplied ? "incl GST 18%" : "excl GST"})
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Amount</div>
                  <div className="batch_amount_to_fix" style={{ fontSize: "14px" }}>
                    <b>₹ {leftSideFinalAmount}</b>
                  </div>
                </div>

                <div className="mt-2 d-flex justify-content-end">
                  <span className="fw-semibold text-secondary" style={{ fontSize: "13px" }}>
                    {isGSTApplied
                      ? `GST Amount Added: ₹${leftSideGstAmount}`
                      : `No GST Applied (₹${leftSideGstAmount})`}
                  </span>
                </div>
              </div>
            </div>

            {/* Right Column (Form) */}
            <div className="col-6" style={{ backgroundColor: "#eef4ff", marginTop: "1rem" }}>
              <form className="mt-4 invoice_form">
                <h5 style={{ textAlign: "center", textDecoration: "underline" }}>Invoice Details</h5>
                <div className="row align-items-center">
                  {/* Case Count */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Case Count</label>
                    <input
                      type="number"
                      className={`form-control border-dark ${fieldErrors.caseCount ? "is-invalid" : ""}`}
                      placeholder="Enter Case Count"
                      value={caseCount}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCaseCount(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          caseCount: !value.trim() || isNaN(value) || parseInt(value) <= 0,
                        }));
                      }}
                      min="0"
                      disabled
                    />
                  </div>
                  {fieldErrors.caseCount && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Case Count must be a valid positive number.
                    </div>
                  )}

                  {/* Invoice No */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Invoice No</label>
                    <input
                      type="text"
                      className={`form-control border-dark ${fieldErrors.invoiceNo ? "is-invalid" : ""}`}
                      placeholder="Enter Invoice No"
                      value={invoiceNo}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInvoiceNo(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          invoiceNo: !value.trim(),
                        }));
                      }}
                      // disabled
                      disabled={ hasInvoiceApprovedStatus()}

                    />
                  </div>
                  {fieldErrors.invoiceNo && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Invoice No is required.
                    </div>
                  )}

                  {/* Invoice Date */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Invoice Date</label>
                    <input
                      type="date"
                      className={`form-control border-dark ${fieldErrors.invoiceDate ? "is-invalid" : ""}`}
                      value={invoiceDate}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInvoiceDate(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          invoiceDate:
                            !value.trim() ||
                            value > new Date().toISOString().split("T")[0],
                        }));
                      }}
                      max={new Date().toISOString().split("T")[0]}
                      disabled
                    />
                  </div>
                  {fieldErrors.invoiceDate && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Invoice Date is required and cannot be a future date.
                    </div>
                  )}

                  {/* Invoice Amount */}
                  <div className="d-flex align-items-center mb-3">
                    <label className="fw-semibold me-2" style={{ width: "200px" }}>Invoice Amount</label>
                    <input
                      type="number"
                      className={`form-control border-dark ${fieldErrors.invoiceAmount || amountError
                        ? "is-invalid"
                        : ""}`}
                      placeholder="Enter Invoice Amount"
                      value={invoiceAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        setInvoiceAmount(value);
                        setFieldErrors((prev) => ({
                          ...prev,
                          invoiceAmount:
                            !value.trim() ||
                            isNaN(value) ||
                            parseFloat(value) <= 0,
                        }));
                        if (value && !isNaN(parseFloat(value))) {
                          if (Math.abs(parseFloat(value) - parseFloat(finalAmount)) > 0.01) {
                            setAmountError("Invoice Amount and Final Amount do not match.");
                          } else {
                            setAmountError("");
                          }
                        } else {
                          setAmountError("");
                        }
                      }}
                      min="0"
                      step="0.01"
                      disabled
                    />
                  </div>
                  {amountError && (
                    <div className="text-danger mt-2" style={{ fontSize: "14px" }}>
                      {amountError}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>


          <div className="d-flex mt-3 justify-content-center gap-3">
            <button
              onClick={downloadCSV}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "rgb(248, 238, 255)",
                border: "1px solid #8000d7",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "14px",
                color: "#8000d7",
              }}
            >
              <FaDownload />
              <span className="ms-2">Download</span>
            </button>
            <button
              onClick={handleSaveData}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "white",
              }}
              disabled={isLoading || !hasAnySelected || !allRowsChecked}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
            <button
              onClick={handleSubmit}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "white",
              }}
              disabled={isLoading || !hasAnySelected}
            >
              {isLoading ? "Processing..." : "Submit"}
            </button>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
          <Modal.Title>
            Edit Invoices (AA No: {editingInvoice?.aA_Number})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Repair Charges</Form.Label>
              <Form.Control
                type="number"
                name="repairCharges"
                value={editValues.repairCharges}
                onChange={handleEditInputChange}
                min="0"
                step="0.01"
                placeholder="Enter Repair Charges"
                size="lg"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Logistics and Repair Support Fees</Form.Label>
              <Form.Control
                type="number"
                name="serviceCharges"
                value={editValues.serviceCharges}
                onChange={handleEditInputChange}
                min="0"
                step="0.01"
                size="lg"
                placeholder="Enter Service Charges"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="remarks"
                value={editValues.remarks}
                onChange={handleEditInputChange}
                placeholder="Enter Remarks"
                className={
                  fieldErrors.remarks[editingInvoice?.aA_Number]
                    ? "is-invalid"
                    : ""
                }
              />
              {fieldErrors.remarks[editingInvoice?.aA_Number] && (
                <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  {" "}
                  Remarks are required for mismatched data.
                </div>
              )}
            </Form.Group>

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label
                className="btn btn-secondary mb-0"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                }}
                onClick={() => modalFileInputRef.current.click()}
              >
                Upload File
              </Form.Label>

              <Form.Control
                type="file"
                id="fileUpload"
                name="uploadedFile"
                onChange={handleRemarkChange}
                style={{ display: "none" }}
                ref={modalFileInputRef}
              />

              {editValues.fileName && (
                <div className="mt-2 text-muted">
                  Selected File: {editValues.fileName}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveEdit}
            style={{
              backgroundColor: "#8000d7",
              border: "none",
            }}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {showRemarkModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content custom-modal">
              <div className="modal-header">
                <h5 className="modal-title">Enter Batch Remark</h5>
                <button type="button" className="btn-close" onClick={() => setShowRemarkModal(false)}></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter your remarks..."
                  value={batchRemark}
                  onChange={(e) => setBatchRemark(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRemarkModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={() => handleSaveRemark(modalActionType)}>Save Remark</button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      <style jsx>{`
        .table-container {
          overflow-x: auto;
          overflow-y: auto;
          max-height: 400px;
          width: 100%;
        }
        .network_table {
          min-width: 1200px;
        }
        .network_table th,
        .network_table td {
          padding: 2px;
          vertical-align: top;
        }
        .vendore_invoice_status {
          display: inline-block;
          white-space: nowrap;
        }
        .page-info {
          margin-top: 1rem;
          font-weight: 500;
        }
        .row-red {
          background-color: #ffe6e6;
          color: #d32f2f;
        }
        .row-yellow {
          background-color: #fff9c4;
        }
        .row-green {
          background-color: #e8f5e9;
        }
      `}</style>
    </div>
  );
};

export default SendbackDetailPage



